/*!
 *  (c)(r) 2008-2025 IT-Service Robert Frunzke
 */

import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';


/**
 * Manja Media Page Navigation Widget ( .mjMediaPageNavWidget )
 *
 * methods:
 *  - TODO
 *
 * usage:
 *  $('#container').mjMediaPageNavWidget( { ... } )
 *
 */

(function($) {

	// using the new $.widget utility..
	$.widget( 'mj.mjMediaPageNavWidget', {

		options: {
		},

		_create: function() {
			var thisWidget = this;

			// init state
			this._page = 1;
			this._npages = 1;
			this._npages_actually_unknown = false;

			// add html controls
			this.element.append('<div class="md-page-ctrls" style="display:none">'
									+'<div title="'+mjt('md-page-first')+'" class="md-page-ctrl md-page-first link"></div>'
									+'<div title="'+mjt('md-page-prev')+'" class="md-page-ctrl md-page-prev link"></div>'
									+'<div class="md-page-ctrl md-page-numbers"><span class="md-page-no">1</span><span class="md-page-slash"> / </span><span class="md-page-count">1</span></div>'
									+'<div title="'+mjt('md-page-next')+'" class="md-page-ctrl md-page-next link"></div>'
									+'<div title="'+mjt('md-page-last')+'" class="md-page-ctrl md-page-last link"></div>'
								+'</div>' );
			var md_page_ctrls = this.element.children('.md-page-ctrls');

			// bind event handlers
			md_page_ctrls
				.children('.md-page-first').click( function() {
					thisWidget.switchPage( 1,false,true); return false;
				} ).end()
				.children('.md-page-prev').click(  function() {
					thisWidget.switchPage(-1, true,true); return false;
				} ).end()
				.children('.md-page-next').click(  function() {
					thisWidget.switchPage( 1, true,true); return false;
				} ).end()
				.children('.md-page-last').click(  function() {
					thisWidget.switchPage(-1,false,true); return false;
				} );

			// bind resize handler
			this.element.on( 'mjsresize.mjMediaPageNavWidget', function(e,w,h) {
				thisWidget._center_page_ctrls(w,h);
			});

			// bind show handler
			this.element.on( 'mjsshow.mjMediaPageNavWidget', function(e) {
				thisWidget._center_page_ctrls(null,null);
			});
		},

		_update_page_ctrls_view: function( do_re_center ) {
			// update view
			var md_page_ctrls = this.element.children('.md-page-ctrls');
			if( this._npages <= 1 ) {
				md_page_ctrls.hide();
			} else {
				md_page_ctrls
					.find('.md-page-no').text(this._page).end()
					.find('.md-page-slash').toggle(!this._npages_actually_unknown).end()
					.find('.md-page-count').toggle(!this._npages_actually_unknown).text(this._npages).end()
					.children('.md-page-first').css( 'opacity', this._page==1 ? '0.3' : '1.0' ).end()
					.children('.md-page-prev').css( 'opacity', this._page==1 ? '0.3' : '1.0' ).end()
					.children('.md-page-next').css( 'opacity', this._page==this._npages ? '0.3' : '1.0' ).end()
					.children('.md-page-last').css( 'opacity', this._page==this._npages ? '0.3' : '1.0' ).end()
					.show();
				if( do_re_center ) this._center_page_ctrls(null,null);
			}
		},

		_center_page_ctrls: function( view_w1, view_h1 ) {
			if( view_w1===null && view_h1===null ) {
				view_w1 = this.element.innerWidth();
				view_h1 = this.element.innerHeight();
			}
			var view_w = Math.max(10,view_w1-10);
			// var view_h = Math.max(10,view_h1-10);
			var md_page_ctrls = this.element.children('.md-page-ctrls'),
				pcx = Math.max( 125, Math.round(view_w/2-(md_page_ctrls.width()||0)/2) );
			if( pcx < 248 ) md_page_ctrls.css( { left:pcx+'px', bottom:'40px' } );	// avoid overlap with md-view-ctrls
			else md_page_ctrls.css( { left:pcx+'px', bottom:'20px' } );
		},

		setupExplicitly: function( page, npages, npages_actually_unknown ) {
			// update state
			this._page = page;
			this._npages = npages;
			this._npages_actually_unknown = npages_actually_unknown;
			// initial view state update..
			this._update_page_ctrls_view(true);
		},

		_getMetadataPageInfo: function( meta ) {
			var npages = 1, npages_actually_unknown = false;
			if( meta[501] && meta[501][0] ) npages = parseInt(meta[501][0],10);							// MSD_TEXT_PAGE_COUNT
			if( meta[227] && parseInt(meta[227][0],10)>npages ) npages = parseInt(meta[227][0],10);		// MSD_IMAGE_PAGE_COUNT
			if( meta[236] && parseInt(meta[236][0],10)>npages ) {
				npages = parseInt(meta[236][0],10);														// MSD_IMAGE_AVAILABLE_PREVIEW_PAGES_COUNT
				npages_actually_unknown = true;
			}
			if( npages < 1 ) npages = 1;
			return [ npages, npages_actually_unknown ];
		},

		_getMetadataPageInfoFrom2Files: function( meta_A, meta_B ) {
			var tmp_A = this._getMetadataPageInfo(meta_A);
			var tmp_B = this._getMetadataPageInfo(meta_B);
			return [ Math.max(tmp_A[0],tmp_B[0]), tmp_A[1] || tmp_B[1] ];
		},

		setupFromFileMetadata: function( page, meta ) {
			// analyze available multi-page-doc info in metadata...
			var tmp = this._getMetadataPageInfo(meta);
			this.setupExplicitly(page,tmp[0],tmp[1]);
		},

		setupFrom2FilesMetadata: function( page, meta_A, meta_B ) {
			var tmp = this._getMetadataPageInfoFrom2Files(meta_A,meta_B);
			this.setupExplicitly(page,tmp[0],tmp[1]);
		},

		getPage: function() {
			return this._page;
		},

		getNPages: function() {
			return this._npages;
		},

		getNPagesActuallyUnknown: function() {
			return this._npages_actually_unknown;
		},

		switchPage: function( page, delta, do_trigger ) {
			// compute new page number
			if( delta ) page = this._page + page;
			else if( page == -1 ) page = this._npages; // -1 -> last
			if( page < 1 ) page = 1;
			else if( page > this._npages ) page = this._npages;
			this._page = page;
			// update page ctrls view state
			this._update_page_ctrls_view(false);
			// trigger event
			if( do_trigger ) this._trigger( 'page_changed', null, { 'page':this._page, 'npages':this._npages, 'npages_actually_unknown':this._npages_actually_unknown } );
		},

		setupKeyboardNavigation: function() {
			if( this._npages>1 ) {
				var thisWidget = this;
				$(document).off('keydown.mjMediaPageNavWidget').on('keydown.mjMediaPageNavWidget', function(e) {
					// ignore keydown if ANY input element is currently focused
					if( $('#md-form').is(':visible') && $('#md-form :focus').filter(':input').length ) return true;
					// ignore keydown, if mmbp-form is visible
					if( $('#mmbp-form').is(':visible') ) return true;
					// handle navigation keys
					switch( e.which ) {
					case 33: // PageUp
					case 38: // UP
						thisWidget.switchPage(-1, true,true);
						return false;
					case 34: // PageDown
					case 40: // DOWN
						thisWidget.switchPage( 1, true,true);
						return false;
					case 36: // POS1
						thisWidget.switchPage( 1,false,true);
						return false;
					case 35: // END
						thisWidget.switchPage(-1,false,true);
						return false;
					}
				} );
			}
		},

		setLoading: function( loading ) {
			//this.element.children('.md-page-ctrls').find('.md-page-no').toggleClass('loading',loading);
			this.element.children('.md-page-ctrls').children('.md-page-numbers').toggleClass('loading',loading);
		},

		_destroy: function() {
			// stop all active timeouts
			// ...none yet...TODO...
			// remove all event handlers
			$(document).off('keydown.mjMediaPageNavWidget');
			this.element.off('.mjMediaPageNavWidget');
			// remove all controls
			this.element.children('.md-page-ctrls').remove();
		},

	} );

})(jQuery);

